export default [
  {
    title: 'Request Penyimpanan',
    customicon: '<span class="k-box-time mr-[10px] text-[20px]"  />',
    tagVariant: 'light-warning',
    resource: 'StorageRequest',
    route: 'storage-request',
    action: 'manage',
    tag: ({ state }) => {
      const s = state?.storageRequestCount
      if (!s) return 0
      return s.total || 0
    },
    onShown: ({ $store }) => {
      $store.dispatch('storageRequestCount/startPolling')
    },
    onHidden: ({ $store }) => {
      $store.dispatch('storageRequestCount/stopPolling')
    },
  },
]
